import { render, staticRenderFns } from "./posLogin.vue?vue&type=template&id=33613c40&scoped=true"
import script from "./posLogin.vue?vue&type=script&lang=js"
export * from "./posLogin.vue?vue&type=script&lang=js"
import style0 from "./posLogin.vue?vue&type=style&index=0&id=33613c40&prod&scoped=true&lang=css"
import style1 from "./posLogin.vue?vue&type=style&index=1&id=33613c40&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33613c40",
  null
  
)

export default component.exports